import type { TFavoriteColors } from 'api/swagger';
import type { IAddMarkerOptions } from 'shared/utils/maps/types.ts';
import { EMarkersZIndexes } from 'shared/utils/maps/types.ts';
import { favoriteColorMapping } from 'types/favorites';
import { EMapMarkerType } from 'types/map';
import { createCircle } from './create-circle';
import styles from './markers.module.scss';

export const addMarker = ({
  map,
  title,
  position,
  onClick,
  type = EMapMarkerType.LOADING,
  warning = false,
  favorites,
  isBelong,
  costValue,
  costView,
}: IAddMarkerOptions): google.maps.marker.AdvancedMarkerElement => {
  const markerContent = document.createElement('div');

  switch (type) {
    case EMapMarkerType.LOADING:
    case EMapMarkerType.UNLOADING:
      markerContent.className = type === EMapMarkerType.LOADING ? styles.geoTag : styles.geoTagUnload;

      if (favorites?.length && !costView) {
        const circleContainer = document.createElement('div');
        circleContainer.className = styles.circleContainer;

        favorites.forEach((color: TFavoriteColors) => {
          const circle = createCircle(favoriteColorMapping[color]);
          circleContainer.appendChild(circle);
        });
        markerContent.appendChild(circleContainer);
      }

      if (costView) {
        markerContent.classList.add(styles.geoTagWithCost);

        const costElement = document.createElement('div');
        costElement.className = styles.costElement;
        costElement.textContent = costValue || '–';
        markerContent.appendChild(costElement);

        const titleElement = document.createElement('div');
        titleElement.className = styles.smallTitle;
        titleElement.textContent = title;

        markerContent.appendChild(titleElement);
      } else {
        const titleElement = document.createElement('div');
        titleElement.textContent = title;

        if (warning) {
          titleElement.textContent = titleElement.textContent + ' ⚠️';
        }

        markerContent.appendChild(titleElement);
      }

      break;

    case EMapMarkerType.CUSTOM:
      markerContent.className = styles.geoTagCustom;
      markerContent.textContent = title;
      break;

    case EMapMarkerType.WAREHOUSE:
      markerContent.className = styles.geoTagWarehouse;
      markerContent.textContent = '📦 ' + title;
      break;

    case EMapMarkerType.EXTERNAL_WAREHOUSE:
      markerContent.className = styles.geoTagExternalWarehouse;
      markerContent.textContent = '📦 ' + title;
      break;

    case EMapMarkerType.ANONYMOUS:
      markerContent.className = styles.geoTagAnonymous;

      if (isBelong) {
        markerContent.classList.add(styles.belong);
      }

      markerContent.textContent = title;
      break;
  }

  const markerView = new google.maps.marker.AdvancedMarkerElement({
    map,
    position,
    content: markerContent,
    zIndex: isBelong ? EMarkersZIndexes.CLIENT_BELONGS_MARKERS : EMarkersZIndexes.OTHER_MARKERS,
  });

  if (onClick) markerView.addListener('click', onClick);

  return markerView;
};
